const ADS_TRACKING_ID = process.env.NEXT_PUBLIC_ADS_TRACKING_ID;

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const addAdEvent = (label: string, callback?: () => void) => {
  if (typeof window === 'undefined' || !window.gtag || !label) {
    return;
  }

  const eventCallback = callback
    ? () => {
        try {
          callback();
        } catch (error) {
          console.error('Error in gtag event callback:', error);
        }
      }
    : undefined;

  window.gtag('event', 'conversion', {
    send_to: `${ADS_TRACKING_ID}/${label}`,
    event_callback: eventCallback,
  });
};
